import { useEffect, useState } from 'react';
import DC from '../../common/DataConnector'
import LocalDataStore from "../../common/LocalDataStore";
import { reducerCartClear } from '../../store/Cart/CartReducer';
import { i18n } from '../../lang/i18n';
import { appDataLoad } from '../../store/AppData/AppData';
import { useNavigate } from 'react-router-dom';
import Helpers from '../../common/Helpers';
import ScrollToTop from '../../components/ScrollToTop';
import { actLoading, actLoadingEnd } from '../../store/Actions';
import { LocationsTypes } from '../../common/Enums';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export default function Locations()
{
    const dispatch = useAppDispatch()
    const appData = useAppSelector((state) => state.appData)
    const location = appData.location
    const schedule = appData.schedule
    const navigate = useNavigate();
    const [locations, setLocations] = useState<any[]>([]);

    useEffect(() =>
    {
        (async function ()
        {
            actLoading(dispatch)
            const content = await DC.Get('/customer/locations', {});
            setLocations(content.data)
            actLoadingEnd(dispatch)
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function onLocationsSelect(index: number)
    {
        const locationCode = locations[index].code;
        LocalDataStore.locationSet(locationCode);
        await appDataLoad(locationCode,dispatch)
        dispatch(reducerCartClear());
        navigate('/' + locationCode)
    }



    return <>
        <ScrollToTop />
        <div className="main-subtitle pt-4">
            {i18n.Locations.Title}
        </div>

        {locations.map((item, index) => (
            item.code === location.code &&
            <div className="location location-current" key={index}>
                {item.typeId !== LocationsTypes.Online && <div className="row p-3 text-center">
                    <div className="col-12 location-title">{item.name}</div>
                    <div className="col-12">{i18n.Locations.TheAddressOfThis}:</div>
                    <div className='col-12'><a
                        href={"https://maps.google.com?q=" + item.latitude + "," + item.longitude} target="_blank"
                        rel="noopener noreferrer">{item.address.route}, {item.address.routeNumber}. {item.address.cp}, {item.address.city}.</a></div>
                    <div className='col-12 schedule mt-3'>
                        <ul><b>{i18n._Labels.Schedule}</b>
                            {Helpers.Schedule(schedule)}
                        </ul>
                    </div>
                </div>}
                {item.typeId === LocationsTypes.Online && <div className="col-12">
                    <div className="location-title">{i18n.Locations.HomeDelivery}</div>
                    <div className='text-center'>
                        <p>
                            Hacemos reparto SOLO en Valladolid Ciudad.
                        </p>
                    </div>
                </div>}
            </div>
        ))}
        {locations.length > 1 && <>
            <div className="main-subtitle mt-4">
                <h3>{i18n.Locations.ChangeRitmo}</h3>
                <small>{i18n.Locations.SelectAnotherLocation}</small>
            </div>
            <div className="locations">
                {locations.map((item, index) => (
                    item.code !== location.code && <div key={index} className="location" >
                        {item.typeId === LocationsTypes.Shop && <div className="col-12 text-center">
                            <h3 className='text-center' onClick={() => onLocationsSelect(index)}>{item.name}</h3>
                            <a href={"https://maps.google.com?q=" + item.latitude + "," + item.longitude}
                                target="_blank"
                                rel="noopener noreferrer">{item.address.route}, {item.address.routeNumber}. {item.address.cp}, {item.address.city}.</a>
                        </div>}
                        {item.typeId === LocationsTypes.Online && <div className="col-12" onClick={() => onLocationsSelect(index)}>
                            <h3 className='text-center'>{i18n.Locations.HomeDelivery}</h3>
                            <div><p></p></div>
                        </div>}
                        <div className="col-12 text-center" onClick={() => onLocationsSelect(index)}>
                            <button className="btn btn-outline-info"><i className="fas fa-check" /> {i18n._BTNs.Select}</button>
                        </div>
                    </div>
                ))}
            </div>
        </>}
    </>
}